import { render } from "./LanguageListing.vue?vue&type=template&id=094baf52"
import script from "./LanguageListing.vue?vue&type=script&lang=js"
export * from "./LanguageListing.vue?vue&type=script&lang=js"
script.render = render

export default script